module.exports = __webpack_public_path__ + "img/show-password-red.eab8c964.svg";